import React, { useState, useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import "dayjs/locale/en";
import "dayjs/locale/cs";

dayjs.extend(relativeTime);


export function useRelativeTime(date: string | null, locale: string = "en") {
  const [relativeTime, setRelativeTime] = useState(() => date ? dayjs(date).locale(locale).fromNow() : "");
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    if (!date) {
      setRelativeTime("");

      return;
    }

    let timeoutId: number;

    const update = () => {
      if (!isMountedRef.current) return;

      setRelativeTime(dayjs(date).locale(locale).fromNow());

      const seconds = (Date.now() - dayjs(date).toDate().getTime()) / 1000;
      const interval = seconds < 60 ? 1000 :
                       seconds < 3600 ? 60000 :
                       seconds < 86400 ? 3600000 :
                                          86400000;

      timeoutId = window.setTimeout(update, interval);
    };
    update();

    return () => {
      isMountedRef.current = false;
      clearTimeout(timeoutId);
    }
  }, [date, locale]);

  return relativeTime;
}


interface ITimestamp {
  date: string | null;
  title?: string;
}


export function Timestamp({
  date,
}: ITimestamp) {
  const intl = useIntl();

  return <time>{dayjs(date).toDate().toLocaleString(intl.locale)}</time>;
}

export function RelativeTimestamp({
  date,
  title,
}: ITimestamp) {
  const intl = useIntl();
  const relativeTime = useRelativeTime(date, intl.locale);

  return <time title={dayjs(date).toDate().toLocaleString(intl.locale)}>{relativeTime}</time>;
}
